/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".conflict-time[_ngcontent-%COMP%]{width:auto!important}.conflict-time[_ngcontent-%COMP%] + .conflict-time[_ngcontent-%COMP%]::before{content:\", \";display:inline-block}.line-h-100[_ngcontent-%COMP%]{line-height:100%}"];
export { styles as styles };
